import classNames from 'classnames';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import styles from './IwLink.module.css';
import { REQUEST_CHANGE_ROUTER } from './IwRouter.actions';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    navigateTo: (location: Partial<Location>, disableRedirect?: boolean) =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location,
            disableRedirect
        })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

class IwLink extends Component<
    {
        disabled?: boolean;
        linkStep?: string;
        className?: string;
        activeClassName?: string;
        disabledClassName?: string;
        onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
        to: string;
        disableRedirect?: boolean;
        'data-testid'?: string;
    } & PropsFromRedux
> {
    getClassName = () => {
        const { disabled, className, disabledClassName } = this.props;

        if (disabled) {
            return classNames(styles.IwLink, disabledClassName);
        }

        return classNames(styles.IwLink, className);
    };

    onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const { disabled, onClick, to, disableRedirect } = this.props;

        event.preventDefault();

        if (!disabled && onClick) {
            onClick(event);
        } else if (!disabled && !onClick) {
            this.props.navigateTo({ pathname: to }, disableRedirect);
        }
    };

    render() {
        return (
            <button
                className={this.getClassName()}
                onClick={this.onClick}
                data-testid={this.props['data-testid']}
            >
                {this.props.children}
            </button>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(IwLink);
